// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum LaneGenerationScope {
	Facility = 0,
	Device = 1,
}

export const LaneGenerationScopeDisplayNames: { [key in keyof typeof LaneGenerationScope]?: string} = {
	"Facility": "Facility",
	0 : "Facility",
	"Device": "Device",
	1 : "Device",
}

export const getLaneGenerationScopeDisplayName = (key: LaneGenerationScope | (keyof typeof LaneGenerationScope & string)) => {
	return LaneGenerationScopeDisplayNames[key];
}

